import React from "react";
import { SectionTitleComponent } from "../components/section-title.component";
import { ContactFormComponent } from "./components/contact-form.component";

interface IContactContainerComponentProps { }

export const ContactContainerComponent: React.FC<
    IContactContainerComponentProps
> = (props: IContactContainerComponentProps) => {
    const section = {
        title: "Contact Us",
        subTitle:
            "Your trusted partner in Payroll, Statutory Compliance & Background Verification Services.",
    };

    return (
        <>
            <section id="contact" className="contact section light-background">
                <SectionTitleComponent
                    title={section.title}
                    subTitle={section.subTitle}
                />
                <div className="container" data-aos="fade" data-aos-delay="100">
                    <div className="row gy-4">
                        <div>
                            <ContactFormComponent />
                        </div>
                    </div>
                </div>
            </section>

            <section
                id="google-map-frame"
                className="google-map-section pricing section pt-2 pb-5"
            >
                <div className="container" data-aos="fade" data-aos-delay="200">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div className="map-wrapper p-3 shadow rounded bg-white">
                                <div className="ratio ratio-16x9 map-ratio">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.021281375501!2d73.82802827496657!3d18.663040982458433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b90076b838bd%3A0x17a01f9c1558819f!2siTalent%20Outsourcing%20Services%20Private%20Ltd.!5e0!3m2!1sen!2sin!4v1744270726795!5m2!1sen!2sin"
                                        width="600"
                                        height="450"
                                        style={{ border: 0 }}
                                        allowFullScreen
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
